function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import useListbox from "../../hooks/use-listbox";
import useSelectRange from "../../hooks/use-select-range";
import Listbox from "./listbox";
import ListboxMultiselectItem from "./listbox-multiselect-item";
import ListboxContent from "./listbox-content";
import ListboxGroup from "./listbox-group";
import ListboxInfoBar from "./listbox-info-bar";
import { TransitionGroup, CSSTransition } from "react-transition-group";

var ListboxMultiselect = function ListboxMultiselect(_ref) {
  var options = _ref.options,
      onChange = _ref.onChange,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? [] : _ref$values,
      emptyValue = _ref.emptyValue,
      onSearch = _ref.onSearch,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      scrollFetch = _ref.scrollFetch,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$showInfoBar = _ref.showInfoBar,
      showInfoBar = _ref$showInfoBar === void 0 ? false : _ref$showInfoBar,
      _ref$maxSelections = _ref.maxSelections,
      maxSelections = _ref$maxSelections === void 0 ? 1000 : _ref$maxSelections,
      size = _ref.size,
      icon = _ref.icon,
      buttonClassName = _ref.buttonClassName,
      hideSelectedValue = _ref.hideSelectedValue,
      headerText = _ref.headerText,
      _ref$headerClassName = _ref.headerClassName,
      headerClassName = _ref$headerClassName === void 0 ? "" : _ref$headerClassName,
      alwaysShowLabel = _ref.alwaysShowLabel,
      _ref$onOpen = _ref.onOpen,
      onOpen = _ref$onOpen === void 0 ? function () {} : _ref$onOpen;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showSelectedOnly = _useState2[0],
      setShowSelectedOnly = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      disableShowSelected = _useState4[0],
      setDisableShowSelected = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isMaxSelections = _useState6[0],
      setIsMaxSelections = _useState6[1];

  var _useListbox = useListbox(options, onSearch, onClose, scrollFetch),
      filteredOptions = _useListbox.filteredOptions,
      flattenedOptions = _useListbox.flattenedOptions,
      _handleSearch = _useListbox.handleSearch,
      handleClose = _useListbox.handleClose,
      filteredCount = _useListbox.filteredCount,
      isGrouped = _useListbox.isGrouped,
      isSearchable = _useListbox.isSearchable;

  var displayOptions = showSelectedOnly ? _.sortBy(values, "value") : filteredOptions;
  var valueCount = values.length;
  var flattenedAndFiltered = isGrouped ? displayOptions.flatMap(function (option) {
    return option.items;
  }) : displayOptions;

  var _useSelectRange = useSelectRange(flattenedAndFiltered, values),
      getSelections = _useSelectRange.getSelections,
      setLastClicked = _useSelectRange.setLastClicked;

  var getDisplayValue = function getDisplayValue() {
    if (valueCount === 0) return "";

    if (valueCount === 1) {
      if (values[0].label) return values[0].label;
      var selected = flattenedOptions.find(function (option) {
        return option.value === values[0].value;
      });
      if (selected) return selected.label;
      return "";
    }

    return "".concat(label, " (").concat(valueCount, " selected)");
  };

  var displayValue = getDisplayValue();
  var labelAndValue = valueCount > 0 ? "".concat(label, ". ").concat(displayValue) : "".concat(label, ". No option selected");

  var handleClick = function handleClick(clickedOption, isShiftKey, isSelected) {
    var selections = getSelections(clickedOption, isShiftKey, isSelected);

    if (selections.length > maxSelections) {
      setIsMaxSelections(true);
      setTimeout(function () {
        setIsMaxSelections(false);
      }, 3000);
    } else {
      setIsMaxSelections(false);
      onChange(selections);
    }
  };

  return /*#__PURE__*/React.createElement(Listbox, {
    ariaLabel: labelAndValue,
    emptyValue: emptyValue,
    value: alwaysShowLabel ? label : displayValue,
    size: size,
    disabled: disabled,
    onClose: function onClose() {
      setShowSelectedOnly(false);
      setLastClicked(null);
      handleClose();
    },
    icon: icon,
    hideSelectedValue: hideSelectedValue,
    buttonClassName: buttonClassName,
    onOpen: onOpen
  }, function (_ref2) {
    var closePopover = _ref2.closePopover;
    return /*#__PURE__*/React.createElement(React.Fragment, null, headerText && /*#__PURE__*/React.createElement("p", {
      className: "listbox-select--header ".concat(headerClassName)
    }, headerText), /*#__PURE__*/React.createElement(ListboxContent, {
      searchable: isSearchable,
      disableSearch: showSelectedOnly,
      filteredCount: filteredCount,
      handleSearch: function handleSearch(val) {
        setLastClicked(null);

        _handleSearch(val);
      },
      scrollFetch: scrollFetch,
      loading: loading,
      setDisableShowSelected: setDisableShowSelected,
      maxSelections: maxSelections,
      isMaxSelections: isMaxSelections
    }, /*#__PURE__*/React.createElement(TransitionGroup, null, displayOptions.map(function (option) {
      return isGrouped ? /*#__PURE__*/React.createElement(ListboxGroup, {
        key: option.label,
        label: option.label,
        showLabel: option.items.length > 0
      }, option.items.map(function (item) {
        return /*#__PURE__*/React.createElement(ListboxMultiselectItem, {
          key: item.value,
          onClick: handleClick,
          option: item,
          isSelected: values.some(function (selected) {
            return selected.value === item.value;
          })
        });
      })) : /*#__PURE__*/React.createElement(CSSTransition, {
        key: option.value,
        timeout: 200,
        classNames: "et-listbox--item-transition"
      }, /*#__PURE__*/React.createElement(ListboxMultiselectItem, {
        onClick: handleClick,
        option: option,
        isSelected: values.some(function (selected) {
          return selected.value === option.value;
        })
      }));
    }))), showInfoBar && isSearchable && /*#__PURE__*/React.createElement(ListboxInfoBar, {
      count: valueCount,
      disableShowSelected: disableShowSelected,
      showSelectedOnly: showSelectedOnly,
      onClear: function onClear() {
        return onChange([]);
      },
      onShowSelected: function onShowSelected(val) {
        setShowSelectedOnly(val);
      }
    }));
  });
};

var optionsFormat = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  icon: PropTypes.string,
  disabled: PropTypes.bool
}));
var groupedOptionsFormat = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string.isRequired,
  items: optionsFormat.isRequired
}));
ListboxMultiselect.propTypes = {
  options: PropTypes.oneOfType([optionsFormat, groupedOptionsFormat]).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,

  /**
   * You can pass an emptyValue if you want to display something other than the default "Select..."
   */
  emptyValue: PropTypes.string,
  onSearch: PropTypes.func,
  onClose: PropTypes.func,
  scrollFetch: PropTypes.func,
  loading: PropTypes.bool,
  values: PropTypes.array,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  buttonClassName: PropTypes.string,
  hideSelectedValue: PropTypes.bool,
  onOpen: PropTypes.func,

  /**
   * showInfoBar = true will add a toolbar to the bottom of the dropdown with the
   * count of items selected, a clear link to clear all selected items, and
   * "View All | View Selected" links to toggle between all options and only selected options.
   * It is important to note that to display selected options that are not in the first
   * page of results, values must include both the value AND label. Also note that the InfoBar
   * should NOT be used with grouped options.
   */
  showInfoBar: PropTypes.bool,
  maxSelections: PropTypes.number,
  size: PropTypes.string,
  headerText: PropTypes.string,
  headerClassName: PropTypes.string,
  alwaysShowLabel: PropTypes.bool
};
export default ListboxMultiselect;